import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-card-moradores',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './card-moradores.component.html',
  styleUrls: ['./card-moradores.component.scss']
})
  
@Injectable()
export class CardMoradoresComponent implements OnInit {

  currentPage: number = 1;
  itemsPerPage: number = 20;
  totalPages: number = 1;
  paginatedItems: any[] = [];
  paginationDots: number[] = [];

  items = [
    { name: 'Saúde', icon: '/assets/svg/saude.svg', count: 2 },
    { name: 'Educação', icon: '/assets/svg/educacao.svg', count: 5 },
    { name: 'Benefícios', icon: '/assets/svg/beneficios.svg', count: 3 },
    { name: 'Trabalho', icon: '/assets/svg/trabalho.svg', count: 4 },
    { name: 'Lazer', icon: '/assets/svg/itens_lazer.svg', count: 6 },
    { name: 'Impostos', icon: '/assets/svg/impostos.svg', count: 7 },
    { name: 'Nota fiscal', icon: '/assets/svg/notaFiscal.svg', count: 8 },
    { name: 'Certidões', icon: '/assets/svg/certidoes.svg', count: 9 },
    { name: 'Transporte', icon: '/assets/svg/transporte.svg', count: 10 },
    { name: 'Cultura', icon: '/assets/svg/cultura.svg', count: 11 },
    { name: 'Área pública', icon: '/assets/svg/areaPublica.svg', count: 12 },
    { name: 'Fiscalização', icon: '/assets/svg/fiscalizacao.svg', count: 13 },
    
    { name: 'Segurança', icon: '/assets/svg/seguranca.svg', count: 2 },
    { name: 'Esporte', icon: '/assets/svg/esportes.svg', count: 5 },
    { name: 'Alvarás', icon: '/assets/svg/alvaras.svg', count: 4 },
    { name: 'Licenças', icon: '/assets/svg/licencas.svg', count: 6 },
    { name: 'Empresas', icon: '/assets/svg/empresas.svg', count: 7 },
    { name: 'Obras', icon: '/assets/svg/obras.svg', count: 8 },
    
  ];
  
  constructor(private router: Router) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo(0, 0);
    });
  }

  ngOnInit(): void {
    this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
    this.updatePaginatedItems();
    this.updatePaginationDots();
  }

  updatePaginatedItems() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.items.slice(startIndex, endIndex);
  }

  updatePaginationDots() {
    this.paginationDots = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedItems();
      this.updatePaginationDots();
    }
  }
  
  navigateToInfo(name: string) {
    this.router.navigate([`/info/${name}`]);
  }
}
